var _a, _b;
import { EnvVariables } from '../types/common-types';
import { configServiceInstance } from '../services/config-service';
export var FILE_END_POINT = configServiceInstance.get(EnvVariables.FILE_END_POINT);
export var PATTERN_STR = '#pattern#';
export var LOGIN_URL = configServiceInstance.get(EnvVariables.LOGIN_URL);
export var REALM = configServiceInstance.get(EnvVariables.REALM);
export var LOCALIZATION_URL = configServiceInstance.get(EnvVariables.LOCALIZATION_URL);
export var OPEN_SUPPORT_RUQUEST_FORM_HASH_KEY = '#open_support_request';
export var AXIOS_URL = configServiceInstance.get(EnvVariables.AXIOS_URL);
export var CHAT_URL = configServiceInstance.get(EnvVariables.CHAT_URL);
export var SIGNALR_URL = configServiceInstance.get(EnvVariables.SIGNALR_URL);
export var HUB_URL = configServiceInstance.get(EnvVariables.HUB_URL);
export var YM_ID = configServiceInstance.get(EnvVariables.YM_ID, true);
export var STAND = ((_a = configServiceInstance.get(EnvVariables.AXIOS_URL)) === null || _a === void 0 ? void 0 : _a.includes('dev'))
    ? 'dev'
    : ((_b = configServiceInstance.get(EnvVariables.AXIOS_URL)) === null || _b === void 0 ? void 0 : _b.includes('stage'))
        ? 'stage'
        : 'production';
export var HELP_EMAIL = 'help@teal-hr.pro';
